export default __webpack_public_path__ + "media/images/logo-92aa25306c4e528da0f29ce11263a6e1.png";